<script>
  import Prism from 'svelte-prism';

  export let language = '';
  export let codeSnippet;
  export let padding = '0 0 0 0';
  export let comment = '';

  const href =
    'https://tutsplus.github.io/syntax-highlighter-demos/highlighters/Prism/prism_okaidia.css';
</script>

<svelte:head>
  <!-- https://tutsplus.github.io/syntax-highlighter-demos/prism.html -->
  <link rel="stylesheet" {href} />
</svelte:head>

<div class="snippet-container" style="padding: {padding}">
  {#if comment}
    <div class="comment-container">
      &lt;!--
      <div class="comment-text">
        {comment}
      </div>

      --&gt;
    </div>
  {/if}
  <Prism {language} showLineNumbers={true} source={codeSnippet} line />
</div>

<style>
  div {
    margin: 0px;
    background-color: #272822;
    border-radius: var(--border-radius);
  }
  .comment-container {
    color: #6a9855;
    padding-left: 2em;
    width: 50%;
    font-size: 0.85rem;
  }
  .comment-text {
    padding-left: 0.5em;
  }
  :global(code[class*='language-']),
  :global(pre[class*='language-']) {
    white-space: pre-wrap !important;
  }
</style>
